export const ease = {
  smooth: [0.16, 1, 0.3, 1] as [number, number, number, number],
  gentle: [0.4, 0, 0.6, 1] as [number, number, number, number],
  subtle: [0.32, 0.72, 0, 1] as [number, number, number, number],
};

export const duration = {
  instant: 0.15,
  quick: 0.25,
  smooth: 0.45,
  deliberate: 0.7,
  ambient: 7,
};

export const stagger = 0.06;

export const fadeUp = {
  initial: { opacity: 0, y: 16 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: duration.smooth, ease: ease.smooth },
};

export const fadeIn = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: duration.smooth, ease: ease.smooth },
};

export const fadeUpItem = (i: number) => ({
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: duration.smooth, delay: i * stagger, ease: ease.smooth },
});
